import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Layout/Footer';

export default function Terms() {
  return (
    <div style={styles.page}>
      <nav style={styles.nav}><Link to="/" style={styles.brand}>ReplyCraft</Link></nav>
      <div style={styles.container}>
        <h1 style={styles.title}>Terms of Service</h1>
        <p style={styles.updated}>Last updated: April 26, 2026</p>

        <div style={styles.content}>
          <h2>1. Acceptance of Terms</h2>
          <p>By creating an account or using ReplyCraft (including our website at replycraft.io and our Chrome Extension), you agree to these Terms of Service. If you do not agree, do not use the service.</p>

          <h2>2. Description of Service</h2>
          <p>ReplyCraft is an AI-powered tool that generates email and message reply suggestions. The service is available as a web application at replycraft.io and as a Chrome browser extension that integrates with Gmail, Outlook Web, Yahoo Mail, and AOL Mail. The service uses artificial intelligence (Claude AI by Anthropic) to create reply options based on the content you provide. Replies are suggestions only — you are responsible for reviewing and editing before sending.</p>

          <h2>3. Chrome Extension</h2>
          <p>The ReplyCraft Chrome Extension is a free tool that adds AI reply generation directly inside supported email platforms. By installing and using the Chrome Extension, you also agree to:</p>
          <ul>
            <li>The extension only accesses email content when you explicitly click the "ReplyCraft" button. It does not run in the background or scan emails passively.</li>
            <li>You must have a valid ReplyCraft account to use the extension's reply generation feature.</li>
            <li>The extension uses your account's credit balance to generate replies (1 credit = 1 word).</li>
            <li>You are responsible for ensuring you have permission to share email content with ReplyCraft for AI processing, especially in business or regulated environments.</li>
            <li>The extension complies with the Chrome Web Store User Data Policy and Limited Use requirements.</li>
            <li>You may uninstall the extension at any time. Uninstalling does not affect your ReplyCraft account.</li>
          </ul>

          <h2>4. Account Registration</h2>
          <p>You must provide a valid email address and verify it to use ReplyCraft. You are responsible for maintaining the security of your account credentials. You must be at least 13 years old to create an account.</p>

          <h2>5. Credits & Payments</h2>
          <ul>
            <li>New accounts receive 1,000 free credits</li>
            <li>Additional credits can be purchased in packs: 50,000 ($5), 150,000 ($10), or 500,000 ($25)</li>
            <li>1 credit = 1 word generated</li>
            <li>Credits never expire</li>
            <li><strong>All credit purchases are final and non-refundable</strong></li>
            <li>Payments are processed securely by Stripe</li>
          </ul>

          <h2>6. Refund Policy</h2>
          <p><strong>All sales are final. Credits are non-refundable once purchased.</strong> We encourage you to use the free credits to test the service before making a purchase. If you experience a technical issue that prevents you from using purchased credits, contact support@replycraft.io and we will investigate on a case-by-case basis.</p>

          <h2>7. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use ReplyCraft to generate spam, harassment, or harmful content</li>
            <li>Attempt to reverse-engineer, exploit, or abuse the service</li>
            <li>Share your account with others or resell credits</li>
            <li>Use automated tools to access the service beyond normal use</li>
            <li>Submit content that violates any laws or third-party rights</li>
          </ul>

          <h2>8. AI-Generated Content Disclaimer</h2>
          <p>Replies generated by ReplyCraft are AI-created suggestions. We do not guarantee their accuracy, appropriateness, or suitability for any specific purpose. You are solely responsible for reviewing, editing, and sending any replies. ReplyCraft is not liable for any consequences arising from the use of generated content.</p>

          <h2>9. Intellectual Property</h2>
          <p>You retain ownership of the content you submit. Replies generated by ReplyCraft are yours to use freely. The ReplyCraft brand, design, and technology are our intellectual property.</p>

          <h2>10. Limitation of Liability</h2>
          <p>ReplyCraft is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the service, including but not limited to lost data, lost revenue, or reputational harm.</p>

          <h2>11. Termination</h2>
          <p>We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time by contacting support. Unused credits are forfeited upon account deletion.</p>

          <h2>12. Changes to Terms</h2>
          <p>We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the new terms.</p>

          <h2>13. Contact</h2>
          <p>Questions about these terms? Contact us at support@replycraft.io or text (540) 322-7406.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: 'var(--bg-primary)', display: 'flex', flexDirection: 'column' },
  nav: { padding: '16px 40px', borderBottom: '1px solid var(--border)' },
  brand: { fontSize: 20, fontWeight: 700, color: 'var(--accent)', textDecoration: 'none' },
  container: { maxWidth: 700, margin: '0 auto', padding: '40px 20px 60px', flex: 1 },
  title: { fontSize: 36, fontWeight: 800, marginBottom: 4, color: 'var(--text-primary)' },
  updated: { color: 'var(--text-muted)', fontSize: 14, marginBottom: 32 },
  content: { color: 'var(--text-secondary)', fontSize: 15, lineHeight: 1.8 },
};
